import CurrencyIcon from "../../assets/img/curreny-icon-euro.svg";
import useTranslator from "../../hooks/useTranslator";
const SalaryCard = ({ effortObj = {} }) => {
  const { _t } = useTranslator();
  return (
    <div className="salary-card">
      <div className="currency-wrapper">
        <span className="currency">
          <img src={CurrencyIcon} alt="Currency Icon" />
        </span>
        <h6>€{effortObj?.monthly_sal}</h6>
      </div>
      <h6 className="total">{_t("total")}</h6>
    </div>
  );
};

export default SalaryCard;
